import React from "react"
import "./About.css"
import AboutImg from "./img/about.png"

function About() {
  window.addEventListener("scroll", function () {
    const UpToTop = document.querySelector("a.button__to__top")
    UpToTop.classList.toggle("active", window.scrollY > 0)
  })
  return (
    <div className="about component__space" id="About">
      <div className="container">
        <div className="row">
          <div className="col__2">
            <img src={AboutImg} alt="" className="about__img"></img>
          </div>
          <div className="col__2">
            <h1 className="about__heading">A propos De Moi</h1>
            <div className="about__meta">
              <p className="about__text p__color">
                Développeur d'applications Web et d'applications mobiles à temps
                plein... J'ai 2 ans d'expérience à ce sujet... Au cours de cette
                période, j'ai réalisé de nombreux types de projets tels que le
                commerce électronique mern stack, les médias sociaux mern stack,
                l'application mobile mern stack Ecommerce, etc. ..
              </p>
              <p className="about__text p__color">
                Je suis principalement un développeur Mern stack mais je connais
                aussi python, php, django, laravel et de nombreux types de
                framework de programmation... J'étudie également avec CSE
                Ingenierie / Ingénierie informatique dans ma région...
              </p>
              <p className="about__text p__color">
                Je suis également un créateur de contenu youtube pour en savoir
                plus sur mon expérience de travail, vous pouvez regarder mon
                tutoriel de programmation... Je suis également fondateur d'une
                grande communauté de programmeurs professionnels... Enfin, je
                crois que je sais quelque chose de bien et je peux vous aider
                pour votre future web project... <br />
                Merci pour votre temps... Bonne journée !
              </p>
              <div className="about__button d__flex align__items__center">
                <a href="#">
                  <button className="about btn pointer">Telecharger CV</button>
                </a>
                <a href="#">
                  <button className="about btn pointer">Me Contacter</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="up__to__top__btn">
        <a href="#" className="button__to__top">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-up white"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
            />
          </svg>
        </a>
      </div>
    </div>
  )
}

export default About
